import React from 'react';
import { Bar } from 'react-chartjs-2';
import numeral from 'numeral';
import './index.css';

export default class Barchart extends React.Component {
    constructor(props) {
      super(props);
      this.state = {}
    }
    prepareChartData() {
        const { rawDataArray, subAttributeLabelName, subAttributeValueName, title } = this.props;
        const barChartOptions = {
            responsive: true,
            legend: {
                display: false,
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function (value) {
                            return numeral(value).format('0,0');
                        },
                    },
                    gridLines: {
                        display:false
                    },
                }],
                xAxes: [{
                    gridLines: {
                        display:false
                    },
                }]
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        return numeral(tooltipItem.yLabel).format('0,0');
                    }
                },
            },
            elements: {
                line: {
                    fill: false,
                    lineTension: 0,
                }
            },
        };
            
        const chartData = {
            labels: rawDataArray?.map(eachPoint => eachPoint[subAttributeLabelName]),
            datasets: [
                {
                    type: 'bar',
                    label: title || 'Chưa có tên',
                    fill: false,
                    backgroundColor: '#00cc66',
                    data: rawDataArray?.map(eachPoint => eachPoint[subAttributeValueName]),
                },
            ],
            barChartOptions,
        };
        return chartData;
    }
    render() {
        const chartData = this.prepareChartData();
        const { height, rawDataArray } = this.props;
        if (rawDataArray && rawDataArray.length <= 0) {
            return (
                <p>Không có dữ liệu</p>
            )
        }
        return (
            <Bar
                data={chartData}
                width={100}
                height={height || 50}
                options={chartData.barChartOptions}
            />
        )
    }
}